import * as React from "react";
// TODO convert to segment ui
export const Select = ({ name, label, options, error, ...rest }: any) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <select name={name} id={name} {...rest} className="form-control">
        <option value="" />
        {options.map((option: any) => (
          <option key={option._id} value={option._id}>
            {option.name}
          </option>
        ))}
      </select>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Form/select.tsx